import store from '@/store'
import { NavigationGuard } from 'vue-router'
import { isPrivate } from './helpers'

const isAuthenticated = () => {
  return store.getters['auth/isAuthenticated']
}

export const authGuard: NavigationGuard = (to, from, next) => {
  if (isPrivate(to) && !isAuthenticated()) {
    next({ name: 'Login' })
  } else {
    next()
  }
}
